'use client';

import { createContext, useContext, useState, PropsWithChildren } from 'react';

interface PeriodicalContextType {
    selectedPeriodicalId?: number;
    setSelectedPeriodicalId: (id?: number) => void;

    canChangeLocation: boolean;
    setCanChangeLocation: (value: boolean) => void;
    isPrinting: boolean;
    setIsPrinting: (isPrinting: boolean) => void;
}

const PeriodicalContext = createContext<PeriodicalContextType | undefined>(undefined);

export const PeriodicalProvider = ({ children }: PropsWithChildren) => {
    const [selectedPeriodicalId, setSelectedPeriodicalId] = useState<number | null>(null);
    const [canChangeLocation, setCanChangeLocation] = useState(false);
    const [isPrinting, setIsPrinting] = useState(false);

    return (
        <PeriodicalContext.Provider
            value={{
                selectedPeriodicalId,
                setSelectedPeriodicalId,
                canChangeLocation,
                setCanChangeLocation,
                isPrinting,
                setIsPrinting,
            }}
        >
            {children}
        </PeriodicalContext.Provider>
    );
};

export const usePeriodicalContext = () => {
    const context = useContext(PeriodicalContext);
    if (!context) {
        throw new Error('usePeriodicalContext must be used within PeriodicalProvider');
    }
    return context;
};
